import { useOutletContext } from 'react-router-dom';
import { useRef, useEffect, useState, useCallback } from 'react';
import './App.css';
import demoVideo from './assets/videos/Vairo3.mp4';
import landingImage from './assets/images/vairo-landing.png';
import { ReactComponent as MagicIcon } from './assets/icons/magic-icon.svg';

function App() {
  const { openCalendly } = useOutletContext();
  const videoRef = useRef(null);
  const [hasStarted, setHasStarted] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const onEnded = () => {
      video.pause();
      setHasStarted(false);
    };

    video.addEventListener('ended', onEnded);
    return () => video.removeEventListener('ended', onEnded);
  }, []);

  const handlePlay = useCallback(() => {
    const video = videoRef.current;
    if (!video) return;
    video.currentTime = 0;
    video.play();
    setHasStarted(true);
  }, []);

  return (
    <>
      <section className="hero">
        <div className="hero-tag">
          <MagicIcon className="hero-tag-icon" aria-hidden="true" />
          AI CASHFLOW AGENTS
        </div>

        <h1 className="hero-title">
          AI That Automates
          <br />
          <span className="hero-title-accent">13-Week Cash Flow Forecasts</span>
        </h1>

        <p className="hero-subtitle">
          AI agents that build, update, and monitor your cash flow model — giving
          you forward visibility and confidence in every cash decision.
        </p>

        <div className="cta-group">
          <div className="cta-item">
            <a
              className="btn-primary"
              href="https://app.vairo.ai/auth?state=signup"
              target="_blank"
              rel="noopener noreferrer"
            >
              Sign Up
            </a>
            <div className="cta-label">Start Free!</div>
          </div>

          <div className="cta-item">
            <button className="btn-secondary" onClick={openCalendly}>Demo</button>
            <div className="cta-label">See platform live</div>
          </div>
        </div>
      </section>

      <div className="product-image-wrapper">
        <div className="product-scroll-sticky">
          <div className="product-image-container">
            <div className="video-wrapper">
              <div className="video-inner">
                {!hasStarted && (
                  <img
                    src={landingImage}
                    alt="Vairo platform preview"
                    className="product-video"
                  />
                )}
                <video
                  ref={videoRef}
                  src={demoVideo}
                  className="product-video"
                  preload="auto"
                  playsInline
                  controls={hasStarted}
                  style={!hasStarted ? { display: 'none' } : undefined}
                />
              </div>
            </div>
          </div>
          {!hasStarted && (
            <div className="video-play-overlay" onClick={handlePlay}>
              <div className="video-play-button">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default App;
